import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ficha-timeline-em-analise-direta',
  templateUrl: './ficha-timeline-em-analise-direta.component.html',
  styleUrls: ['./ficha-timeline-em-analise-direta.component.css'],
})
export class FichaTimelineEmAnaliseDiretaComponent implements OnInit {
  @Input() timeline: any;
  @Input() timelineActive: boolean;
  @Input() idFicha: string;
  @Input() cliente: object;
  @Input() produtoProposta: any;

  constructor() {}

  ngOnInit() {}
}
